// extracted by mini-css-extract-plugin
module.exports = {"footerLink":"FooterLink_footer-link__wogoG","footerLinkText":"FooterLink_footer-link-text__pBISb"};